import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/Home.vue'
import BaomaPayment from '@/views/BaomaPayment.vue'
import LakalaPayment from '@/views/LakalaPayment.vue'
import LakalaWechatPayment from '@/views/LakalaWechatPayment.vue'
import ClientDetect from '@/views/ClientDetect.vue'
import TestApi from '@/views/TestApi.vue'
import TestProxy from '@/views/TestProxy.vue'
import ApiTest from '@/views/ApiTest.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    // 确保路由能处理带参数的URL
    props: (route) => ({ ...route.query })
  },
  {
    path: '/baoma',
    name: 'BaomaPayment',
    component: BaomaPayment
  },
  {
    path: '/lakala',
    name: 'LakalaPayment',
    component: LakalaPayment
  },
  {
    path: '/lakala-wechat',
    name: 'LakalaWechatPayment',
    component: LakalaWechatPayment
  },
  // 移除WechatPayment路由
  {
    path: '/client-detect',
    name: 'ClientDetect',
    component: ClientDetect
  },
  {
    path: '/test-api',
    name: 'TestApi',
    component: TestApi
  },
  {
    path: '/test-proxy',
    name: 'TestProxy',
    component: TestProxy
  },
  {
    path: '/api-test',
    name: 'ApiTest',
    component: ApiTest
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 添加全局路由守卫来处理带参数的路由
router.beforeEach((to, from, next) => {
  console.log('路由守卫 - 导航到:', to);
  console.log('路由守卫 - 来自:', from);
  next();
});

// 添加路由后置钩子来处理参数
router.afterEach((to, from) => {
  console.log('路由后置钩子 - 导航到:', to);
  console.log('路由后置钩子 - 来自:', from);
});

// 添加错误处理
router.onError((error) => {
  console.error('路由错误:', error);
});

export default router